export const jsonInputSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  title: "EasyMapsImport",
  type: "object",

  properties: {
    rootMapId: { type: "string" },
    maps: {
      type: "array",
      items: {
        type: "object",
        properties: {
          id: { type: "string" },
          titulo: { type: "string" },
          tipo: { type: "number" },
          createAt: { type: "string" },

          ConfigMapEasyMaps: {
            type: ["object", "null"],
            properties: {
              id: { type: "string" },
              mapId: { type: "string" },

              configuracoes: {
                type: "object",
                properties: {
                  // o configMapModal grava "geo"/"top"/"ftth" e o toolbarMaps
                  // regrava com o número do mapa (0/1); exports têm os dois
                  tipo: { type: ["string", "number"] },

                  alerts: { type: "object" },
                  animacao: { type: "object" },
                  camadaTrafego: { type: "object" },
                  camadaPotencia: { type: "object" },
                },
                additionalProperties: true,
              },

              createAt: { type: "string" },
              updateAt: { type: "string" },
            },
            required: ["id", "mapId", "configuracoes"],
          },
        },
        required: ["id", "titulo", "tipo"],
      },
    },

    elements: {
      type: "array",
      items: {
        type: "object",
        properties: {
          id: { type: "string" },
          titulo: { type: "string" },
          tipo: { type: "number" },
          font: { type: ["string", "null"] },
          mapRefId: { type: ["string", "null"] },
          mapId: { type: "string" },
          img: { type: ["string", "null"] },

          elementConfig: {
            type: "object",
            properties: {
              id: { type: "string" },
              elementId: { type: "string" },

              config: {
                type: "object",
                properties: {
                  hosts: {
                    type: "array",
                    items: {
                      type: "object",
                      properties: {
                        host: { type: "string" },
                        hostid: { type: "string" },
                        hostname: { type: "string" },

                        tags: { type: "array" },
                        itens: { type: "array" },
                        interfaces: { type: "array" },
                      },
                      required: ["host", "hostid", "hostname"],
                    },
                  },

                  produtoId: { type: "string" },

                  coordenadas: {
                    type: "object",
                    properties: {
                      lat: { type: ["number", "string"] },
                      long: { type: ["number", "string"] },
                    },
                    required: ["lat", "long"],
                  },
                },
                // produtoId não é obrigatório: a importação não usa o campo e
                // elementos sem produto (caixa de texto, área) saem sem ele
                required: ["hosts", "coordenadas"],
              },
            },
          },

          element: {
            type: "array",
            items: { type: "object" },
          },
        },
        required: ["id", "titulo", "tipo", "mapId"],
      },
    },

    elementConfigs: {
      type: "array",
      items: {
        type: "object",
      },
    },

    relations: {
      type: "array",
      items: {
        type: "object",
        properties: {
          id: { type: "string" },
          referenceId: { type: "string" },
          destinationId: { type: "string" },

          item: { type: "array" },
          positionHandlers: { type: ["array", "null"] },

          config: {
            type: "object",
          },
        },
        required: ["id", "referenceId", "destinationId"],
      },
    },
  },

  required: ["maps", "elements", "elementConfigs", "relations"],

  additionalProperties: false,
};
